// @ts-strict-ignore
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LMChartBase } from './lm-chart-base';
import { SohoLineComponent } from 'ids-enterprise-ng';
import * as d3 from 'd3';

@Component({
  selector: 'lm-chart-line',
  template: `
    <div soho-line
        [dataset]="dataset"
        [redrawOnResize]="true"
        [showLegend]="showLegend"
        [emptyMessage]="emptyMessage"
        [isArea]="isArea"
        [isBubble]="isBubble"
        [hideDots]="hideDots"
        [animate]="animate"
        [tooltip]="tooltip"
        [xAxis]="xAxisObj"

        (selected)="onSelected($event)"
        (rendered)="onRendered($event)"
        (unselected)="onUnselected($event)"
        (contextmenu)="onContextMenu($event)"
    ></div>
    <ng-container *ngIf="!isDashBoardContent">
      <div *ngIf="isBubble && xAxisFields.length" [ngStyle]="{'margin-top': '-25px;'}" id="axisSelectors">
        <div class="field" [ngStyle]="{'float': 'left'}">
          <label attr.for="{{getXAxisId()}}" soho-label lm-label>X-Axis</label>
          <!--
          todo swolyniec fieldClassesString doesn't seem to be defined in lm-chart-line component
          [ngClass]="fieldClassesString"
          -->
          <select
              id="{{getXAxisId()}}" name="{{getXAxisId()}}" class="xAxis"
              soho-dropdown noSearch (change)="onXAxisChanged($event)"
          >
            <option *ngFor="let chartField of xAxisFields" >{{chartField.label.resourceValue}}</option>
          </select>
        </div>
        <div class="field" [ngStyle]="{'float': 'left', 'padding-left': '10px'}">
          <label attr.for="{{getYAxisId()}}" soho-label lm-label>Y-Axis</label>
          <!--
          todo swolyniec fieldClassesString doesn't seem to be defined in lm-chart-line component
          [ngClass]="fieldClassesString"
          -->
          <select
              id="{{getYAxisId()}}" name="{{getYAxisId()}}" class="yAxis"
              soho-dropdown noSearch (change)="onYAxisChanged($event)"
          >
            <option *ngFor="let chartField of yAxisFields" >{{chartField.label.resourceValue}}</option>
          </select>
        </div>
      </div>
    </ng-container>
    <!-- FOR Line CHART
           tooltip(value: string)  xAxis(value: object)  yAxis(value: object)  axisLabels(value: any)
           animate(value: boolean)  dots(value: object)
    -->
            `
  })
export class LMChartLineComponent extends LMChartBase implements OnInit { // implements OnInit
  @ViewChild(SohoLineComponent, { static: true }) sohoLineComponent: SohoLineComponent;

  @Input() isArea: boolean;
  @Input() isBubble: boolean;
  @Input() isDateChart: boolean;
  @Input() hideDots: boolean;
  @Input() isDashBoardContent: boolean;
  @Input() xAxisFields: Array<LMChartField>;
  @Input() yAxisFields: Array<LMChartField>;
  @Input() xAxisId: string;
  @Input() yAxisId: string;

  @Output() axisChanged = new EventEmitter<ChartEvent>();

  public xAxisObj;
  private el: HTMLElement;
  private selections = { xSelected: 0, ySelected: 0 };

  constructor(
    public elementRef: ElementRef,
  ) {
    super(elementRef);
  }

  ngOnInit() {
    if (!this.isDateChart) {
      this.xAxisObj = { rotate: this.getRotateAngle(this.dataset[0].data.length) };
      return;
    }

    // D3 parse/format date
    const parseDate = d3.timeParse('%m/%d/%Y');
    const formatDate = d3.timeFormat('%b %d %y');

    const dataX = this.dataset[0].data;
    // Get dates
    const dates = dataX.map((d, i) => {
      const tDate = new Date(d.name);
      const dt = parseDate(tDate.toLocaleDateString());
      //     d.tooltip = d.localeDate;  //  + ' ' + this.dataset[0].data[i].value;
      return  dt;
    });

    // Get min and max dates
    const minDate = (d3.min(Object.values(dates)));
    const maxDate = d3.max(Object.values(dates));
    const ticks = this.getTicks(minDate, maxDate);

    this.xAxisObj = {
      scale: d3.scaleTime(),
      domain: [ minDate, maxDate ],
      rotate: this.getRotateAngle(999), // force to angle on date chart
      ticks, // d3.time.months, // d3.timeDay.every(50), // 10, //  d3.months,
      formatter(d, i) {
        const options = {
        //  weekday: 'short',
          year: 'numeric',
          month: '2-digit',
          day: 'numeric'
        };
        return  d.toLocaleString(Soho.Locale.currentLocale, options); // formatDate(d);
      },
      parser(d, i) {
        return parseDate(d.name);
      }
    };
  }

  public onXAxisChanged(event: JQuery.TriggeredEvent) {
    this.selections.xSelected = event.target.selectedIndex;
    const chartAxisChangedEvent: ChartAxisChangedEvent = {
      event,
      xSelectionIndex: this.selections.xSelected,
      ySelectionIndex: this.selections.ySelected,
    };

    this.axisChanged.emit(chartAxisChangedEvent);
  }

  public onYAxisChanged(event: JQuery.TriggeredEvent) {
    this.selections.ySelected = event.target.selectedIndex;
    const chartAxisChangedEvent: ChartAxisChangedEvent = {
      event,
      xSelectionIndex: this.selections.xSelected,
      ySelectionIndex: this.selections.ySelected,
    };

    this.axisChanged.emit(chartAxisChangedEvent);
  }

  public getXAxisId(): string {
    return this.xAxisId ? this.xAxisId : 'xAxis';
  }

  public getYAxisId(): string {
    return this.yAxisId ? this.yAxisId : 'yAxis';
  }

  private getRotateAngle(ticks: number): string {
    if (ticks > this.elementRef.nativeElement.offsetWidth / 80) {
      return '-65';
    }
    // return undefined to allow D3 to use default.
    return undefined;
  }

  private getTicks(dt1, dt2): number {
    const maxTicks = 25;

    const yearDiff = this.yearsDiff(dt1, dt2);
    if (yearDiff > 2 && yearDiff < maxTicks) {
      return yearDiff;
    }
    const monthDiff = this.monthDiff(dt1, dt2);
    if (monthDiff > 4 && monthDiff < maxTicks) {
      return monthDiff;
    }
    const dayDiff = this.dayDiff(dt1, dt2);
    if (dayDiff > 3 && dayDiff < maxTicks) {
      return dayDiff;
    }
    return maxTicks;
  }

  private yearsDiff(dt1, dt2) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= (60 * 60 * 24);
    return Math.abs(Math.round(diff / 365.25));
  }

  private monthDiff(dt1, dt2) {
    let months;
    months = (dt2.getFullYear() - dt1.getFullYear()) * 12;
    months -= dt1.getMonth() + 1;
    months += dt2.getMonth();
    return months <= 0 ? 0 : months;
  }

  private dayDiff(dt1, dt2) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round((dt2 - dt1) / (1000 * 60 * 60 * 24));
  }

  public getChartComponent() {
    return this.sohoLineComponent;
  }
}
